export enum MAP_CENTER_TYPE {
    INITIAL_CENTER = 'initialCenter',
    BOUNDARY_CENTROID = 'boundaryCentroid',
    USER_LOCATION = 'userLocation'
}

export { DEFAULT_ZOOM } from 'components/Map/constants';

export { DEFAULT_PADDING } from 'hooks/useMapBox/constants';
